import styled from 'styled-components';

import { useSearchAndShuffleContext } from '../../context';

export type CardContainerProps = {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  href?: string;
  dataQa?: string;
  className?: string;
};

export const CardElementLink: React.FC<CardContainerProps> = ({
  children,
  onClick,
  href,
  dataQa,
  className,
}) => {
  const { cardLinksEnabled } = useSearchAndShuffleContext();

  const clickHandler = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    if (!cardLinksEnabled.current) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    onClick?.(e);
  };

  return (
    <Link
      onClick={clickHandler}
      href={href}
      data-qa={dataQa}
      className={className}
    >
      {children}
    </Link>
  );
};

const Link = styled.a`
  cursor: pointer;
`;
